import React, { useContext, useEffect } from "react";
import { FormattedMessage } from "react-intl";

import ErrorBanner from "@/components/Commons/ErrorBanner/ErrorBanner";
import { ChatWithITSupportFlyoutLink } from "@/components/GetSupport";
import { RefPageValue } from "@/components/GetSupport/ChatWithITSupport/types";
import { AppContext } from "@/stores/appStore";
import { ActionType } from "@/stores/constants";

/**
 * The error message to inform NHs when there are some issues with their accounts.
 */
export const AccountIssue = ({
  refPage,
}: {
  refPage: RefPageValue;
}): JSX.Element => {
  const { dispatch } = useContext(AppContext);

  /**
   * Set the refPage to provide context to IT Support should the new hire initiate
   * a chat with support
   */
  useEffect(() => {
    dispatch({
      type: ActionType.SET_CHAT_SUPPORT_REF_PAGE,
      chatSupportRefPage: refPage,
    });
  }, []);

  return (
    <ErrorBanner>
      <FormattedMessage
        id="error-accountIssues"
        data-test-id="accountIssueDataTestId"
        values={{
          chatWithITSupportLink: (
            <ChatWithITSupportFlyoutLink localeMessageId="text-chatWithITSupport" />
          ),
        }}
      />
    </ErrorBanner>
  );
};
